import m from "../../geodata/es2015/spainHigh";
window.am4geodata_spainHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/spainHigh.js
// module id = null
// module chunks = 